export const parseJson = (jsonString, fallback = 0) => {
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    if(fallback !== 0) return fallback;
    return jsonString;
  }
}